import React from 'react';
import { Container, Typography, Paper, Box, Divider, Link } from '@mui/material';

export default function Imprint() {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                <Typography variant="h4" fontWeight={800} gutterBottom>
                    Impressum
                </Typography>
                
                <Divider sx={{ my: 3 }} />

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Angaben gemäß § 5 DDG
                    </Typography>
                    <Typography variant="body1">
                        Albert Programmierung<br />
                        Tim Albert<br />
                        Blauenstr. 3<br />
                        79415 Bad Bellingen
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Kontakt
                    </Typography>
                    <Typography variant="body1">
                        Telefon: +49 (0) 160 / 966 899 79<br />
                        E-Mail: service@albert.tools
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
                    </Typography>
                    <Typography variant="body1">
                        Tim Albert<br />
                        Blauenstr. 3<br />
                        79415 Bad Bellingen
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        EU-Streitschlichtung
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <Link href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</Link>. Unsere E-Mail-Adresse finden Sie oben im Impressum.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Verbraucherstreitbeilegung/Universalschlichtungsstelle
                    </Typography>
                    <Typography variant="body1">
                        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Haftung für Inhalte
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Haftung für Links
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Urheberrecht
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Datenschutzerklärung
                    </Typography>
                    <Typography variant="body1" paragraph>
                        1. Verantwortliche Stelle<br />
                        Tim Albert<br />
                        Albert Programmierung<br />
                        Blauenstr. 3<br />
                        79415 Bad Bellingen<br />
                        Telefon: +49 (0) 160 / 966 899 79<br />
                        E-Mail: service@albert.tools
                    </Typography>
                    <Typography variant="body1" paragraph>
                        2. Hosting und Server-Logfiles<br />
                        Beim Aufruf dieser Website verarbeitet unser Hosting-Dienstleister automatisch sogenannte Server-Logfiles (z.B. IP-Adresse, Datum und Uhrzeit des Abrufs, Zeitzonendifferenz, aufgerufene URL, Referrer-URL, Browsertyp und Browserversion, Betriebssystem). Die Verarbeitung ist technisch erforderlich, um die Website stabil und sicher auszuliefern (Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO). Die Daten werden gelöscht, sobald sie für die Zweckerreichung nicht mehr erforderlich sind.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        3. Kontaktaufnahme per E-Mail oder Telefon<br />
                        Wenn Sie uns kontaktieren, verarbeiten wir die von Ihnen mitgeteilten Daten (insbesondere Name, Kontakt- und Kommunikationsdaten sowie Inhaltsangaben), um Ihr Anliegen zu beantworten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit es um vorvertragliche oder vertragliche Anfragen geht, im Übrigen Art. 6 Abs. 1 lit. f DSGVO. Die Daten geben wir nicht ohne Ihre Einwilligung weiter und löschen sie, sobald sie für die Bearbeitung nicht mehr erforderlich sind.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        4. Keine Cookies, kein Tracking<br />
                        Diese Website setzt keine Cookies, verwendet keine Analyse- oder Trackingdienste und bindet keine Social-Media-Plugins ein.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        5. Ihre Rechte<br />
                        Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten: Recht auf Auskunft, Berichtigung oder Löschung, Einschränkung der Verarbeitung, Widerspruch gegen die Verarbeitung sowie Recht auf Datenübertragbarkeit. Sie haben zudem das Recht, sich bei einer Aufsichtsbehörde zu beschweren.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        6. Stand<br />
                        Stand: Dezember 2025
                    </Typography>
                </Box>

                <Box>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Bildnachweise
                    </Typography>
                    <Typography variant="body1">
                        Headerbilder<br />
                        Quelle: Vielen, vielen Dank an fancycrave1<br />
                        by Albert Programmierung (2023) Impressum
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
}